import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

export const LockoutCountdown = ({ seconds, email, onExpire }) => {
  const [left, setLeft] = useState(seconds);

  useEffect(() => { setLeft(seconds); }, [seconds]);

  useEffect(() => {
    if (left <= 0) { onExpire(); return undefined; }
    const t = setTimeout(() => setLeft((v) => v - 1), 1000);
    return () => clearTimeout(t);
  }, [left, onExpire]);

  return (
    <div className="rounded-lg border border-destructive/30 bg-destructive/5 p-3 text-sm space-y-1.5" data-testid="login-lockout">
      <p className="flex items-center gap-2 font-medium text-destructive">
        <Lock className="w-4 h-4" /> Sign-in locked — try again in{" "}
        <span className="tabular-nums" data-testid="login-lockout-countdown">{fmt(Math.max(left, 0))}</span>
      </p>
      <p className="text-muted-foreground">
        Locked out?{" "}
        <Link to={`/forgot-password${email ? `?email=${encodeURIComponent(email)}` : ""}`}
          className="text-primary font-medium hover:underline" data-testid="login-lockout-reset-link">
          Reset your password
        </Link>{" "}
        to unlock immediately.
      </p>
    </div>
  );
};
